import { useSelector } from 'react-redux';
import { useCallback } from 'react';
import { IFormWidgetCallbackProps } from '@cian/frontend-request-form-widget';

import { selectServicePageInfo } from '../../../selectors/servicePageInfo';
import { createCianAnalyticsPageViewObject } from '../../../utils/createCianAnalyticsPageViewObject';
import { trackEvent } from '../../../utils/tracking';
import { EStepCode } from '../../../types/requestFormSchema';
import { IRequestFormValue } from '../../../types/requestFormValue';
import { getStepValueLabel } from './getStepValueLabel';
import { IRequestFormQuestion } from '../../../types/requestForm/requestFormQuestion';
import { TRequestFormCallbackProps } from '../../../types/requestForm';

export interface IUseRequestFormTrackingResult {
  trackNext: (props: TRequestFormCallbackProps) => void;
  trackPrev: () => void;
  trackSubmit: () => void;
}

export const useRequestFormTracking = (): IUseRequestFormTrackingResult => {
  const servicePageInfo = useSelector(selectServicePageInfo);

  const trackPrev = useCallback<() => void>(() => {
    trackEvent({
      action: 'Click',
      label: 'previous',
      ...createCianAnalyticsPageViewObject(servicePageInfo),
    });
  }, [servicePageInfo]);

  const trackSubmit = useCallback<() => void>(() => {
    trackEvent({
      action: 'Click',
      label: 'to_pay',
      ...createCianAnalyticsPageViewObject(servicePageInfo),
    });
  }, [servicePageInfo]);

  const trackNext = useCallback<(props: IFormWidgetCallbackProps<IRequestFormValue, IRequestFormQuestion>) => void>(
    props => {
      const caPageViewObject = createCianAnalyticsPageViewObject({
        ...servicePageInfo,
        // Закрываю ситуацию, когда при первом переходе к следующему шагу в стор еще не установлен текущий шаг.
        currentStep: props.fromStep.code as EStepCode,
      });

      trackEvent({
        action: 'Click_next',
        label: getStepValueLabel(props),
        ...caPageViewObject,
      });
    },
    [servicePageInfo],
  );

  return {
    trackNext,
    trackPrev,
    trackSubmit,
  };
};
